import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

/** Full-page chrome for the developer portal and admin queue (matches Domains/Projects). */
export function PageShell({ crumb, aside, children }: { crumb: string; aside?: ReactNode; children: ReactNode }) {
  return (
    <div className="ui-root min-h-dvh bg-page">
      <header className="sticky top-0 z-30 border-b border-hairline bg-page/70 backdrop-blur-[14px]">
        <div className="mx-auto flex max-w-[1080px] items-center gap-2.5 px-4 py-3 sm:gap-3 sm:px-7">
          <Link
            to="/"
            title="Back to Dunea"
            className="ui-btn-icon text-secondary hover:text-primary"
            aria-label="Back to Dunea"
          >
            <div className="i-ph:arrow-left text-[16px]" />
          </Link>
          <div className="flex items-center gap-2">
            <img src="/dunea-mark.svg" width={20} height={20} alt="" />
            <span className="ui-brand hidden text-[17px] text-primary sm:inline">Dunea</span>
          </div>
          <span className="text-faint">/</span>
          <span className="truncate text-[13px] text-secondary">{crumb}</span>
          <div className="flex-1" />
          {aside}
        </div>
      </header>
      <main className="mx-auto max-w-[1080px] px-4 pb-20 pt-7 sm:px-7 sm:pt-10">{children}</main>
    </div>
  );
}

export function PageHeading({ caption, title, lede }: { caption: string; title: ReactNode; lede?: ReactNode }) {
  return (
    <div className="mb-8">
      <span className="ui-caption">{caption}</span>
      <h1 className="mt-2 font-instrument text-[32px] leading-[1.05] tracking-[-0.02em] text-primary sm:text-[44px]">
        {title}
      </h1>
      {lede && <p className="mt-3 max-w-xl text-[13.5px] leading-relaxed text-secondary">{lede}</p>}
    </div>
  );
}
